import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StorageConst } from '../../shared/consts/storage-consts';

@Injectable()
export class SalesMonitorGuard implements CanActivate {

  constructor(
    private router: Router,
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const credentials = this.getCredentials();
    if (!(credentials.x && credentials.y && credentials.accessCode)) {
      return false;
    }

    /**
     * If the credentials exists in localStorage but not exist in current browser url
     * replace current url with all credentials
     *
     * The if statement prevents from recursion !!!
     */
    if (
      (!route.queryParams.accessCode || !route.queryParams.x || !route.queryParams.y) &&
      (credentials.x && credentials.y && credentials.accessCode)
    ) {
      return this.router.createUrlTree([this.getUrlFromRouteSnapshot(route)], {
        queryParams: {
          ...route.queryParams,
          ...credentials
        }
      });
    }

    return true;
  }

  public getCredentials = () => ({
    accessCode: sessionStorage.getItem(StorageConst.ACCESS_CODE),
    x: sessionStorage.getItem(StorageConst.X),
    y: sessionStorage.getItem(StorageConst.Y)
  })

  private getUrlFromRouteSnapshot = (route: ActivatedRouteSnapshot): string => (
    route.pathFromRoot
      .filter(v => v.url.length)
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/')
  )
}
